export const MOBILE_FAMILY_ACCOUNT_TOKEN_KEY = 'flcMobileFamilyAccountToken';
export const MOBILE_FAMILY_STATE_ACTIVE = 'active';
export const MOBILE_FAMILY_STATE_RESET_REQUIRED = 'reset_required';
export const MOBILE_FAMILY_STATE_SUSPENDED = 'suspended';

export const getMobileFamilyState = (payload) => {
  const state = String(payload?.mobileFamilyState || '').trim().toLowerCase();
  if (state === MOBILE_FAMILY_STATE_RESET_REQUIRED || state === MOBILE_FAMILY_STATE_SUSPENDED) {
    return state;
  }
  return MOBILE_FAMILY_STATE_ACTIVE;
};

export const clearMobileFamilyForRegistration = () => {
  localStorage.removeItem(MOBILE_FAMILY_ACCOUNT_TOKEN_KEY);
  localStorage.removeItem('jwtToken');
  localStorage.removeItem('flcMobileSkipSplashOnce');
};

export const clearMobileLearnerSession = () => {
  localStorage.removeItem('jwtToken');
  localStorage.removeItem('flcMobileSkipSplashOnce');
};
